import React from 'react';

import createStyle from 'shared-utils/src/createStyle';

import Save from 'shared-vectors/icons/StarSlim';
import Saved from 'shared-vectors/icons/Stared';
import PinMap from 'shared-vectors/icons/PinMap';
import { Icon } from 'shared-vectors';

import Grid from '../../../../../Grid';
import GridItem from '../../../../../GridItem';

import Tooltip from '../../../Tooltip';

import styles, { mainCls, mapCls } from './style';

import { useCardContext } from '../../../../index';

const useStyles = createStyle(styles);

export default function Contacts({
  saved,
  publisher,
  visible,
  actions, }) {
  const { maplist, mapcard } = useCardContext();

  const cls = useStyles();

  const {
    publisherName,
    publisherUrl,
    publisherType,
    publisherLogo,
    hasCrossSubscription,
  } = publisher;

  const isPrivate = publisherType === 'Private';
  const logoStr = publisherLogo || '';
  const hasPlaceholder = !!(logoStr.indexOf('agencylogo') > -1 || logoStr.indexOf('placeholder') > -1);
  const logo = hasPlaceholder ? logoStr.replace('/', '') : logoStr;

  const resize = hasCrossSubscription
    ? '125x60-resize/'
    : '';

  const logoImg = !hasPlaceholder
    ? (
      <img
        className={`${cls[`${mainCls}__agz__logo`]} mr--s pm is-rel`}
        src={visible ? `https://images-1.casa.it/${resize}${logo}` : null}
        alt={`Vedi tutti gli annunci dell'agenzia ${publisherName}`}
      />
    ) : null;
  
  return (
    <GridItem
      behavior="fixed"
      className={cls[maplist ? mapCls : mainCls]}
    >
      <Grid
        align="center"
        justify="space-between"
        noWrap
      >
        <GridItem behavior="fixed">
          {isPrivate ? (
            <span className={`${cls[`${mainCls}__agz`]} tp-s--x2s tp-w--s c-txt--f0 tp--up is-rel`}>
              Inserzionista privato
            </span>
          ) : (
            <a
              className={`${cls[`${mainCls}__agz`]} tp-s--s tp-w--s c-txt--f0 is-rel`}
              href={publisherUrl}
              title={`Vedi tutti gli annunci dell'agenzia ${publisherName}`}
              target={maplist ? '_blank' : ''}
            >
              {logoImg}
              <span className={cls[`${maplist ? mapCls : mainCls}__agz__name`]}>
                {publisherName}
              </span>
            </a>
          )}
        </GridItem>
        <GridItem behavior="fixed">
          <Grid
            align="center"
            justify="space-between"
            noWrap
          >
            <button
              type="button"
              className={`${cls[`${mainCls}__sendmail`]} ml--s pt--xs pr--s pb--xs pl--s tp-s--s tp-w--s c-txt--f0 c-bg--w b--s is-rel is-clickable`}
              onClick={actions.sendMail}
            >
              Contatta
            </button>
            {maplist && !mapcard ? (
              <Tooltip
                text="Vedi su mappa"
                topCoords={-35}
                className={`${cls[`${mainCls}__savectn`]} is-rel`}
              >
                <button
                  type="button"
                  className={`${cls[`${mainCls}__pin`]} c-txt--secondary c-bg--tr is-rel is-clickable`}
                  onClick={actions.showOnMap}
                >
                  <Icon name={PinMap} width="24px" height="24px" fill />
                </button>
              </Tooltip>
            ) : null}            
            <Tooltip
              text={saved ? 'Elimina' : 'Salva'}
              topCoords={-35}
              className={`${cls[`${mainCls}__savectn`]} is-rel`}
            >
              <button
                type="button"
                className={`${cls[`${mainCls}__save`]} c-bg--w c-txt--secondary is-rel is-clickable`}
                onClick={actions.toggleFavorite}
              >
                <Icon
                  name={saved ? Saved : Save}
                  width="20px"
                  height="20px"
                />
              </button>
            </Tooltip>
          </Grid>
        </GridItem>
      </Grid>
    </GridItem>
  );
}